/* eslint-disable max-len */
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {
    selectChapterRead,
    selectComicsForChapter,
    selectDatedProgressForChapter,
} from '../../../store/reducers';
import {webMediaQuery} from '../../../styles';
import ProgressBar from '../../ProgressBar';

const ComicsChapterCard = props => {
    let points = makeMask(
        props.maskStart,
        props.maskEnd,
        props.horizontal,
        props.width,
        props.height,
    );

    //let imageHeight = props.height - 57;
    let imagePoints = makeMask(
        props.maskStart,
        props.maskEnd,
        props.horizontal,
        props.width - 16,
        props.height,
    );

    const {t} = useTranslation();
    const comic = useSelector(state =>
        selectComicsForChapter(state, props.chapter.id),
    );
    var read = useSelector(state => selectChapterRead(state, props.chapter.id));
    var progress = useSelector(
        state =>
            selectDatedProgressForChapter(state, props.chapter.id)?.progress ||
            0,
    );

    return (
        <StyledLink
            to={`/comics/${comic.friendlyName}/${props.chapter.number}`}
            replace={props.replace}
        >
            <Container {...props} points={points}>
                <ImageContainer height={props.height - 57} points={imagePoints}>
                    <ChapterImage
                        src={`${comic.baseUrl}/${props.chapter.folder}/${props.chapter.cover}`}
                    />
                    <StyledProgressBar percent={progress} />
                </ImageContainer>
                <ChapterText>
                    {t('comics.chapter')} {props.chapter.number}
                </ChapterText>
                <ShowText>{comic.show}</ShowText>
                {read && (
                    <ReadImage
                        src={require('../../../assets/ic_chapter_read.png')}
                    />
                )}
            </Container>
        </StyledLink>
    );
};

const makeMask = (maskStart, maskEnd, horizontal, width, height) => {
    if (horizontal) {
        return `${maskStart ? 16 : 0}px 0px, ${width}px 0px, ${
            maskEnd ? width - 16 : width
        }px ${height}px, 0px ${height}px`;
    } else {
        return `0px ${maskStart ? 16 : 0}px, ${width}px 0px, ${width}px ${
            maskEnd ? height - 16 : height
        }px, 0px ${height}px`;
    }
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    background-color: white;
    clip-path: ${props => `polygon(${props.points})`};
    transition: transform 0.35s cubic-bezier(0.68, -0.51, 0.22, 1.68);
    position: relative;

    &:hover {
        ${webMediaQuery} {
            transform: scale(1.02);
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        }
    }
`;

const ImageContainer = styled.div`
    position: relative;
    margin: 8px;
    width: 100%;
    height: ${props => props.height}px;
    clip-path: ${props => `polygon(${props.points})`};
`;

const ChapterImage = styled.img`
    width: 100%;
    height: 100%;

    object-fit: cover;
`;

const ChapterText = styled.div`
    font-family: 'AvenirNextRoundedStd';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    color: black;
    margin: 0px 8px;
    text-transform: uppercase;
`;

const ShowText = styled.div`
    font-family: 'AvenirNextRoundedStd';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    align-items: center;
    color: black;
    margin: 0px 8px;
`;

const StyledLink = styled(Link)`
    position: relative;
    color: transparent;
`;

const ReadImage = styled.img`
    position: absolute;
    bottom: 30px;
    right: 24px;
    width: 48px;
    height: 41px;
`;

const StyledProgressBar = styled(ProgressBar)`
    position: absolute;
    bottom: 0px;
`;

export default ComicsChapterCard;
